(function() {
'use strict';

angular
    .module('TR')
    .controller('LandingPage', LandingPage);

function LandingPage(
        $injector,
        resourceService,
        imageService,
        $rootScope,
        $timeout,
        pageStrand,
        loggingService,
        holidayDeals,
        filtering,
        $location,
        $scope,
        recentHotels,
        hotelService,
        $route,
        $filter,
        $routeParams,
        destinationService,
        searchUnitService,
        currentDestination,
        $q,
        broker,
        supportedProducts,
        analytics,
        occupancyService,
        tripService,
        objectTypeService,
        fidParser) {
    const lp = this;
    const seoData = {};
    let destination;

    $rootScope.lockScreen($scope, {
        loadingScreenStyle: 'default-landingPageCtrl'
    });

    $scope.landingPageV2Loaded = () => {
        if ($location.search().autoSearch !== '1') {
            broker.publish('landingPageV2Loaded');
            loadDeals();
        }
    };

    delete $route.current.$$route.area;

    function loadDeals() {
        $q.all([
            holidayDeals.find({ pageSize: 8, destination, saveToUrl: false, includeCruises: false }),
            filtering.getFilters(holidayDeals.getDefaultFilters(), pageStrand.get('Holiday'))
        ]).then(([deals, filters]) => {
            _.forEach(deals.Products, deal => deal.ImageUrl = deal.CroppedImage);
            $scope.deals = {
                Products: deals.Products,
                Aggregates: deals.Aggregates,
                Filters: filters
            };
        });
    }

    $scope.goToDeal = deal => {
        let selected = deal.HolidayDeals[0];
        let estabId = deal.Id;
        let occupancy = occupancyService.getOccupancy();
        $scope.$emit('block', {
            title: resourceService.get('LOADINGHOTELS'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: 'default-landingPageCtrl-selectRecommendation'
        });
        tripService
            .getTripIdForHolidayDeal(selected, occupancy)
            .then(tripId => $location.path(`/holidays/${tripId}/${estabId}`));
    };

    currentDestination.getCurrentDestination()
        .then(updateDest)
        .then(updateNoIndexFollow)
        .then(getSeoData)
        .then(setDOMContent)
        .then(() => {
            if ($location.search().autoSearch !== '1') {
                broker.publish('unblock');
            }
        });

    function updateDest(dest) {
        if (dest == null) {
            loggingService.logWarn(`failed to look up destination for friendly url ${$routeParams.landingPage}`);
            $rootScope.unlockScreen($scope);
            $location.replace();
            $location.path('pagenotfound');
            return dest;
        }

        lp.destination = dest;

        //if this is a hotel it's always going to have pagestrand 1 so we need to customer for the tm=1 qs param
        if (destinationService.destinationIsEstab(dest)) {
            analytics.track('mixpanel', dest.PageStrand === 1 ? 'HotelLandingPage' : 'HolidayLandingPage');
            analytics.incrementPeopleEvent(dest.PageStrand === 1 ? 'HotelLandingPage visit' : 'HolidayLandingPage visit');
        }


        function supportedProduct() {
            if (dest.PageStrand === 1) {
                return supportedProducts.isProductSupported(supportedProducts.products.hotels);
            }
            return supportedProducts.isProductSupported(supportedProducts.products.holidays);
        }

        if (!supportedProduct()) {
            $location.replace();
            $location.path('/');
            $rootScope.unlockScreen($scope);
            $q.reject();
            return;
        }


        destination = { Type: dest.Type, Id: dest.Id };

        $route.current.$$route.area = pageStrand.toRoute(dest.PageStrand);

        //we might be coming back here from selecting a new destination from the autocompleter in mobile
        //so we need to check whether destination is already and we are just changing it in the search unit
        const currentDest = searchUnitService.getDestination();
        if (currentDest == null || !currentDest.changed) {
            return searchUnitService.setDestination(dest, false, true).then(setTemplate);
        }
        return setTemplate(dest);
    }

    function getSeoData(dest) {
        // Get available SEO data once `setTemplate` has run
        if (dest == null) { return; }

        const subscriberName = 'landingPageCtrl';

        // Get resource strings
        seoData.inOrNearStr = resourceService.get(
            dest.IsPOI ? 'NearDestination' : 'InDestination'
        );

        // Hotel
        if ($scope.hotel) {
            return dest; // No extra data needed
        } else if (destinationService.destinationIsCountry(dest)) { // Country
            // Get lowest price when data is ready
            analytics.track('mixpanel', 'CountryLandingPage');
            analytics.incrementPeopleEvent('CountryLandingPage visit');
            return $q(resolve => {
                broker.subscribeOnce(subscriberName, 'landingPageV2Loaded', () => {
                    resolve(dest);
                });
                broker.subscribeOnce(subscriberName, 'destTopChildrenRetrieved', results => {
                    seoData.price = getLowestPrice(
                        results && results.data, 'MinHotelPrice'
                    );
                    resolve(dest);
                });
            });
        }
        // Not Hotel or Country
        // Get lowest price when data is ready
        return $q(resolve => {
            broker.subscribeOnce(subscriberName, 'landingPageV2Loaded', () => {
                resolve(dest);
            });
            broker.subscribeOnce(subscriberName, 'hotelResultsModified', results => {
                const data = results && results.data;
                seoData.price = getLowestPrice(
                    data && data.Hotels, 'IndicativeMinPrice'
                );
                resolve(dest);
            });
        });
    }

    function setDOMContent(dest) {
        if (dest == null) { return; }

        const dataPoints = [
        // `alt` is resource name to use if transformed string exceeds `max` length
            { name: 'MetaTitle', max: 59, alt: 'AltMetaTitle' },
            { name: 'MetaDescription', max: 159, alt: 'AltMetaDescription' },
            { name: 'PageTitle' },
            { name: 'PageHeading' }
        ];
        const hotel = $scope.hotel;
        dest.IsPreview = ($routeParams.ispreview !== undefined && $routeParams.ispreview.toLowerCase() === 'true');
        // Create content from string templates
        destinationService.getText(dest)
            .then(templStrings => {
                // Get values from available data
                const varMap = getVarMap(hotel, dest);
                const descStrings = {};

                // Replace {vars} in `templStrings`
                dataPoints.forEach(dataPoint => {
                    const dataName = dataPoint.name;
                    const maxChars = dataPoint.max;
                    const templStr = templStrings[dataName] || '{name}';
                    let transformedStr = String.supplant(templStr, varMap) || '';

                    // If `max` chars specified, use `alt` template if it exists
                    if (maxChars && transformedStr.length > maxChars) {
                        const altTemplStr = templStrings[dataPoint.alt];
                        if (altTemplStr) {
                            transformedStr = String.supplant(altTemplStr, varMap);
                        }
                    }
                    descStrings[dataName] = transformedStr;
                });

                // Add HotelSummary if available
                descStrings.HotelSummary = hotel && hotel.Summary || undefined;
                descStrings.MetaRobots = templStrings.MetaRobots || undefined;
                // Image url i.e. `og:image`
                descStrings.imageURL = imageService.getLandingPageImage(dest);

                // Update HTML elements
                updateDOM(descStrings);
            });
    }

    function getAbParam() {
        let qs = $location.search();
        const fid = fidParser.parse();
        if (fid || qs.fbt || qs.fstr || qs.hpr) {
            return 1;
        }
        return qs.ab || TRPCONFIG.Domain.LandingPagesV2Control || 1;
    }

    function getTemplate(dest, ab) {
        const strand = pageStrand.toRoute(dest.PageStrand);
        let params = objectTypeService.getObjectTypeAndId(dest);
        params.ab = ab;

        switch (destinationService.getDestinationType(dest)) {
            case destinationService.country:
                return $q.when(`partials/${strand}/country?${$.param(params)}`);
            case destinationService.estab:
                recentHotels.set(dest.EstablishmentId);

                return hotelService.getHotel(null, dest.EstablishmentId).then(function(hotel) {
                    broker.publish('hotelCacheReady', hotel);
                    delete hotel.Rooms;
                    $scope.hotel = hotel;
                    return `partials/${strand}/hotellanding?landing=true`;
                });

            default:
                params.landing = true;
                return $q.when(`partials/${strand}/hotelsearch?${$.param(params)}`);
        }
    }

    function setTemplate(dest) {
        let ab = getAbParam(dest);
        return getTemplate(dest, ab).then(function(template) {
            lp.template = template;
            return dest;
        });
    }

    function getLowestPrice(hotels, priceProp) {
        const prices = [];
        if (Array.isArray(hotels)) {
            hotels.forEach(hotel => {
                const price = hotel && hotel[priceProp];
                if (price) {
                    prices.push(price);
                }
            });
        }
        return _.min(prices) || undefined;
    }

    function getVarMap(hotel, dest) {
    // Variable mapping in string templates i.e. {name}
    // Also supports legacy numeric vars i.e. {0}
        const getBcTitle = destinationService.getBreadcrumbTitle;

        // If hotel data exists
        if (hotel) {
            return {
                0: hotel.Title,
                1: seoData.inOrNearStr,
                2: `${hotel.Province}, ${hotel.Country}`,
                name: hotel.Title,
                in: seoData.inOrNearStr,
                price: $filter('roundedCurrency')(hotel.IndicativeMinPrice),
                province: hotel.Province,
                country: hotel.Country,
                location: hotel.Location
            };
        }

        // Else get destination data
        return {
            0: dest.Title,
            1: seoData.inOrNearStr,
            name: dest.ShortTitle,
            in: seoData.inOrNearStr,
            price: $filter('roundedCurrency')(seoData.price),
            country: getBcTitle(dest, bc => bc.ObjectId === dest.CountryId),
            province: getBcTitle(dest, bc => bc.ObjectId === dest.ProvinceId),
            number: `${dest.HotelCount}` // String for continuity
        };
    }

    function updateDOM(descStrings) {
        // Update page title
        document.title = descStrings.PageTitle;

        // Replace or create DOM <head> elements: {selector: htmlStr, ...}
        $.each({
            'meta[name=title]':
                `<meta name="title" content="${descStrings.MetaTitle}">`,
            'meta[name=description]':
                `<meta name="description" content="${descStrings.MetaDescription}">`,
            'meta[property="og:title"]':
                `<meta property="og:title" content="${descStrings.MetaTitle}">`,
            'meta[property="og:description"]':
                `<meta property="og:description" content="${descStrings.HotelSummary || descStrings.MetaDescription}">`
            },
            (selector, htmlStr) => {
                $(selector).remove();
                $('head').append(htmlStr);
            }
        );
        //Update meta robots
        if (_.get(descStrings, 'MetaRobots.length') > 0) {
            const robots = $('meta[name="robots"]');
            if (robots.length > 0) {
                robots.attr('content', descStrings.MetaRobots);
            } else {
                $('head').append(`<meta name="robots" content="${descStrings.MetaRobots}">`);
            }
        }
        // Update or create og:image
        // If present replace the standard site logo, otherwise add the 'og:image' tag from scratch
        const ogImage = $('meta[name="og:image"]');
        if (ogImage) {
            ogImage.attr('content', descStrings.imageURL);
        } else {
            $('head').append(`<meta property="og:image" content="${descStrings.imageURL}">`);
        }
    }

    function updateNoIndexFollow(dest) {
        if (dest && dest.HotelCount === 1) {
            const destinationType = destinationService.getDestinationType(dest);
            if (destinationType !== destinationService.estab) {
                broker.publish('ISNOINDEXFOLLOW', { isNoIndexFollow: true });
            }
        }
        return dest;
    }
}
})();
